import {
  IonButtons,
  IonContent,
  IonIcon,
  IonHeader,
  IonMenuButton,
  IonToolbar,
  IonRouterLink,
  IonBadge,
  IonAvatar,
  IonPopover,
  IonAlert,
  IonLabel,
  IonModal,
  IonButton,
  IonTextarea,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { menuController } from "@ionic/core/components";
import "./Header.scss";
import { AuthService } from "../../../services/authService";
import { useTranslation } from "react-i18next";
import i18n from "../../../locales/i18n/i18n";
import {
  power,
  settings,
  menuOutline,
  ellipsisVertical,
  sunny,
  moon,
  chatboxEllipses,
  star,
} from "ionicons/icons";
import { useHistory, useLocation } from "react-router-dom";
import classNames from "classnames/bind";
import { useToast } from "@agney/ir-toast";
import { statusBoardMenuConstants } from "../../../constants/MenuObjects";
import { StorageService, utilService } from "../../../services";
import { NotificationsApiResponse } from "../../../pages/Notifications/NotificationsDataModels";
import { NotificationsService } from "../../../pages/Notifications/NotificationsService";
import { loggedInUserService } from "../../../services/loggedInUser.service";
import _ from "lodash";
import MenuSettingsList from "../../../pages/MenuSettings/components/MenuSettingsList/MenuSettingsList";
import { pushNotificationService } from "../../../services/PushNotification.service";
import { settingsService } from "../../../pages/MenuSettings/components/Settings/Settings.service";
import { dataTransferService } from "../../../services/dataTransferService";
import CustomToggle from "../../../pages/MenuSettings/components/Settings/components/CustomToggle";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import { headerService } from "./Header.service";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { useDarkMode } from "../../../helpers/ThemeContext";
import { MenuContext } from "../../../router/AppLayout/AppLayout";
import { rolePermissionsService } from "../../../services/rolePermissions.service";
import { useNetwork } from "../../../helpers/NetworkContext";

interface HeaderProps {
  isCollapsed?: boolean;
  setIsCollapsed?: (value: boolean) => void;
}

const Header: React.FC<HeaderProps> = ({ isCollapsed = false, setIsCollapsed }) => {
  const location = useLocation();
  const Toast = useToast();
  let history = useHistory();
  const {selectedNetwork} = useNetwork();
  const { menuListGlobal, setMenuListGlobal } = useContext<any>(MenuContext);
  const { t } = useTranslation("header");

  const currentTime = new Date();
  var [menuList, setMenuList]: any = useState([]);
  var [userDetails, setUserDetails]: any = useState([]);
  const [profilePic, setProfilePic] = useState<string>("");
  var [isLargeSCreen, setIsLargeScreen]: any = useState(true);
  const [isHeaderActive, setIsHeaderActive] = useState(true);
  const [isMenuSettingActive, setIsMenuSettingsActive] = useState(false);
  const [routerLink, setRouterLink] = useState("/client/menu-settings");
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isMyContactNumberClicked, setIsMyContactNumberClicked] =
    useState(false);
  const [themeType, setTheme] = useState(false);
  var [isEMTUser, checkEMTUser]: any = useState(false);

  const [showStatusMessage, setShowStatusMessage] = useState(false);
  const [statusMessage, setStatusMessage] = useState<string>("");
  const [statusMessageID, setStatusMessageID] = useState<string>();
  const [isEmptyMessage, setEmptyMessage] = useState(false);
  const [messageAvailable, setMessageAvailableStatus] = useState(false);
  const [isOnUSer,setIsOnUSer] = useState(false)

  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  const [notificationCount, setNotificationCount]: [number, Function] =
    useState(0);

  document.addEventListener("mouseup", function (e: any) {
    var container: any = document.getElementsByClassName("status-board-menu");
    if (container && container.length) {
      container[0].style.display = "none";
    }
  });

  const { isDarkModeContext } = useDarkMode();

  useEffect(() => {
    statusMessage ? setEmptyMessage(false) : setEmptyMessage(true);
  }, [statusMessage]);

  // Subscribe to changes in the notification count.
  //
  // This had no dependency array and no teardown, so the Header -- which stays
  // mounted for the whole session -- added another live subscription on every
  // single render and never dropped one.
  useLayoutEffect(() => {
    const subscription = NotificationsService.notificationCount.subscribe(
      (data: any) => {
        if (data) {
          setNotificationCount(formatNotificationCount(data.result?.[0]?.count));
        }
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getProfileUpdatedAction.subscribe(
      (data: any) => {
        if (data === true) {
          loggedInUserService.setLoggedInUserData();
        } else {
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useLayoutEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setUserDetails(data);
      let isEmtUser = checkIsEMTUser(data?.userData);
      checkEMTUser(isEmtUser);
      // Set profilePic only when userData is present
      // if (data && data.userData) {
      //   const pic = data.userData.image;
      //   if (pic && pic !== "") {
      //     setProfilePic(pic);
      //   } else {
      //     setProfilePic("assets/images/defaultProfilePic.png");
      //   }
      // }
    });
    // Re-subscribed on every navigation and never tore down, so the handler
    // count grew with the number of pages the user visited.
    return () => subscription.unsubscribe();
  }, [location.pathname]);

  useEffect(()=>{
    
setProfilePic(userDetails?.userData?.image || "assets/images/defaultProfilePic.png")
  },[userDetails])

  useEffect(() => {
    if (isEMTUser) {
      toggleDarkModeHandler(isDarkModeContext);
      setTheme(isDarkModeContext);
    }
  }, [isDarkModeContext]);

  useEffect(() => {
    const isDarkMode = getThemeStatusFromStorage();
    toggleDarkModeHandler(isDarkMode);
    setTheme(isDarkMode);

    if (Capacitor.getPlatform() === "ios") {
      if (isDarkMode === true) {
        StatusBar.setStyle({ style: Style.Dark });
      } else {
        StatusBar.setStyle({ style: Style.Light });
      }
    }
  }, []);

  useEffect(() => {
    checkIfLargeScreen();
    // Removing status board menu item from menuListGlobal
    setMenuList(() => {
      return menuListGlobal.filter((menuItem: any) => menuItem.menuId !== 11);
    });
    getNotifications();
  }, [menuListGlobal]);

  useEffect(() => {
    if (
      !_.isEmpty(location.state) &&
      location.pathname === "/client/menu-settings"
    ) {
      const currentLocation: any = location;
      if (currentLocation.state.isMyContactNumberClicked) {
        setIsMyContactNumberClicked(true);
      }
    } else {
      setIsMyContactNumberClicked(false);
    }
  }, [location]);

  function openMenu() {
    menuController.open();
  }

  const closeMenu = () => {
    menuController.close();
  };

  // Revoking the session on the server is awaited rather than raced against a
  // one-second timer -- AuthService.logout() navigates away, which would
  // cancel the request while it was still in flight.
  const logout = async () => {
    await pushNotificationService.deleteToken();
    AuthService.logout();
  };

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "large") {
      setIsLargeScreen(true);
    } else {
      setIsLargeScreen(false);
    }
  };

  const checkIsEMTUser = (loggedInUser: any): any => {
    if (loggedInUser) {
      return loggedInUser.roles.some(function (item: any) {
        return item.name === CONSTANTS.ROLES.EMT;
      });
    }
  };

  const getNotifications = async () => {
    let reqParams: { [key: string]: any } = {
      guid: utilService.getLoggedUserGuid(),
      page: 1,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      "cat-list": JSON.stringify([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
      reg_code: utilService.getNetwork(),
    };
    const notificationsListResponse: NotificationsApiResponse =
      await NotificationsService.getNotifications(reqParams);
    if (notificationsListResponse.isSuccess) {
      if (notificationsListResponse.result?.[0]?.count) {
        setNotificationCount(
          formatNotificationCount(notificationsListResponse.result?.[0]?.count)
        );
      }
    }
  };

  const formatNotificationCount = (count: number) => {
    return count > 999 ? (count / 1000).toFixed(1) + "k" : count;
  };

  const onMenuSettingsBtnClicked = () => {
    if (!isMenuSettingActive || location.pathname !== "/client/menu-settings") {
      history.push({
        pathname: "/client/menu-settings",
      });
      setIsMenuSettingsActive(true);
      setRouterLink(location.pathname);
    } else {
      history.push(routerLink);
      setIsMenuSettingsActive(false);
    }
  };

  const setMenuActive = (item: any) => {
    if (item === window.location.pathname) {
      // window.location.reload();
    }
  };

  const confirmToast = (data: any, e: any) => {
    toggleDarkModeHandler(e);
  };

  const toggleDarkModeHandler = (status: boolean) => {
    if (Capacitor.getPlatform() === "ios") {
      if (status === true) {
        StatusBar.setStyle({ style: Style.Dark });
      } else {
        StatusBar.setStyle({ style: Style.Light });
      }
    }

    document.body.className = status ? "dark-theme" : "light-theme";
    setTheme(status);
    changeThemeStatusStorage(status);
  };

  const changeThemeStatusStorage = (status: boolean) => {
    const savePasswordStatus = utilService.getSavePasswordStatus();
    var currentStorage;
    if (savePasswordStatus) {
      currentStorage = localStorage;
    } else {
      currentStorage = sessionStorage;
    }
    StorageService.setStorageItem(
      currentStorage,
      {
        isDarkMode: status,
      },
      true
    );
  };

  const getThemeStatusFromStorage = () => {
    const savePasswordStatus = utilService.getSavePasswordStatus();
    const isDarkMode = StorageService.getStorageItem(
      CONSTANTS.STORAGE[true === savePasswordStatus ? 1 : 0],
      "isDarkMode",
      true
    );
    if (isDarkMode === "true") {
      return true;
    } else {
      return false;
    }
  };

  const getUserStatusMessage = async () => {
    let Params = {
      guid: utilService.getLoggedUserGuid(),
    };
    const getUserStatusMsg: any = await headerService.userStatusMessage(Params,"");
    if (getUserStatusMsg.isSuccess) {
      let userStatusMessage =
        getUserStatusMsg.result?.[0]?.profile_status_message.status_message;
      let userStatusMessageId =
        getUserStatusMsg.result?.[0]?.profile_status_message.id;
      userStatusMessage
        ? setMessageAvailableStatus(false)
        : setMessageAvailableStatus(true);
      userStatusMessage ? setEmptyMessage(false) : setEmptyMessage(true);
      setStatusMessage(userStatusMessage);
      setStatusMessageID(userStatusMessageId);
    } else {
    }
  };

  const addStatusMessage = async () => {
    let Params = {
      status_message: statusMessage,
    };
    const addUserStatusMsg: any = await headerService.addUserStatusMessage(
      Params
    );
    if (addUserStatusMsg.isSuccess) {
      Toast.success(addUserStatusMsg.message);
    } else {
    }
  };

  const updateStatusMessage = async () => {
    let Params = {
      status_message: statusMessage,
      id: statusMessageID,
    };
    const addUserStatusMsg: any = await headerService.updateUserStatusMessage(
      Params
    );
    if (addUserStatusMsg.isSuccess) {
      Toast.success(addUserStatusMsg.message);
    } else {
    }
  };


  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("appLanguage", lang);
    localStorage.setItem("lang", lang);
  };

  const [isN2nPermission, setisN2nPermission] = useState<any>(false);

  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setisN2nPermission(data?.userData?.n2nActivation)
    });
    return () => subscription.unsubscribe();
  }, []);


  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setIsOnUSer(data?.userData?.roleBasedPermission?.isOnUser)
    });
    return () => subscription.unsubscribe();
  }, [])

  return (
    <div className="app-header">
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => {
          setIsShowAlert(false);
        }}
        cssClass="sign-off-alert"
        header={t("confirmationMessage")}
        message={t("signOffConfirmation")}
        buttons={[
          {
            text: t("no"),
            handler: () => {},
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: t("yes"),
            handler: () => {
              logout();
            },
          },
        ]}
      />
      <IonHeader
        className={classNames({
          "main-header": true,
        })}
      >
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
            <div
              className="sidebar-collapse-toggle"
              onClick={() => setIsCollapsed && setIsCollapsed(!isCollapsed)}
              title="Collapse menu"
            >
              <IonIcon icon={menuOutline} />
            </div>
          </IonButtons>
          <div className="app-header-container">
            {isN2nPermission&& !isOnUSer && (
              <div
                className="n2n-search-icon"
                title={t("n2nSearch")}
                hidden={isEMTUser}
                onClick={() => {
                  history.push("/client/n2n-search");
                }}
              >
                <N2NIcon />
              </div>
            )}
            {!isOnUSer&&<div
              className="user-status-message"
              title={t("statusMessage")}
              hidden={isEMTUser}
              onClick={() => {
                setShowStatusMessage(true);
                getUserStatusMessage();
              }}
            >
              <IonIcon
                className="status-update"
                icon={chatboxEllipses}
              ></IonIcon>
            </div>}
            {!isOnUSer&&<div
              className="global-user-search"
              title={t("globalSearch")}
              hidden={isEMTUser}
            >
              <IonRouterLink routerLink="/client/globalUserSearch">
                <div className="clickable icon-no_result user-look-up"></div>
              </IonRouterLink>
            </div>}
            {isLargeSCreen && isEMTUser && (
              <div className="theme-selector-container">
                <div
                  className={`toggle-button-wrapper ems-theme-toggler ${
                    themeType ? "toggle-dark-mode" : ""
                  }`}
                >
                  {themeType && (
                    <div className="toggle-image">
                      <IonIcon slot="start" icon={sunny} />
                    </div>
                  )}
                  <CustomToggle
                    isSelected={themeType}
                    type={CONSTANTS.SETTING_OPTIONS.TOGGLE_THEME}
                    confirmToast={confirmToast}
                  ></CustomToggle>
                  {!themeType && (
                    <div className="toggle-image">
                      <IonIcon slot="start" icon={moon} />
                    </div>
                  )}
                </div>
              </div>
            )}

            {isLargeSCreen && !isEMTUser && !isOnUSer && (
              <>
                <div className="lookup-btn-wrapper">
                  <IonRouterLink routerLink="/client/oncalllookup">
                    <div
                      className="clickable lookup"
                      onClick={() => setMenuActive("/client/oncalllookup")}
                    >
                      {t("onCallLookup")}
                    </div>
                  </IonRouterLink>
                  <IonRouterLink routerLink="/client/favorites">
                    <div
                      className="fav-btn-div"
                      onClick={() => setMenuActive("/client/favorites")}
                    >
                      {t("favorite")}
                    </div>
                  </IonRouterLink>
                </div>
              </>
            )}

            {utilService.getScreenSize() === "small" && (
              <IonRouterLink routerLink="/client/favorites">
                <div className="user-status-message" title={t("statusMessage")}>
                  <IonIcon
                    className="status-update"
                    icon={star}
                    hidden={isEMTUser}
                    onClick={() => setMenuActive("/client/favorites")}
                  ></IonIcon>
                </div>
              </IonRouterLink>
            )}
            <div className="icon-wrapper notifications-icon position-relative">
              <IonRouterLink routerLink="/client/notifications">
                <span
                  className="icon-notification"
                  onClick={() => setMenuActive("/client/notifications")}
                ></span>
                {location.pathname !== "/client/notifications" && (
                  <IonBadge color="danger">{notificationCount}</IonBadge>
                )}
              </IonRouterLink>
            </div>
            {!_.isEmpty(userDetails)  && (
              <div className="profile-pic-div">
                <IonAvatar className="profile-pic">
                  <img
                    src={profilePic && profilePic !== "" ? profilePic : "assets/images/defaultProfilePic.png"}
                    alt="Profile"
                    className="doctor-profile-image"
                    onError={(
                      e: React.SyntheticEvent<HTMLImageElement, Event>
                    ) => {
                      const target = e.target as HTMLImageElement;
                      target.src = "assets/images/defaultProfilePic.png";
                    }}
                  />
                </IonAvatar>
              </div>
            )}
            {!_.isEmpty(userDetails) && isLargeSCreen && (
              <div className="name-label-div">
                <div className="name-label">
                  Hi{" "}
                  {userDetails.userData.displayName
                    ? userDetails.userData.displayName
                    : userDetails.userData.firstName}
                </div>
              </div>
            )}
            {isLargeSCreen && (
              <div
                className="icon-wrapper"
                onClick={() => setIsShowAlert(true)}
                title={t("signOff")}
              >
                <IonIcon icon={power} title={t("signOff")} />
              </div>
            )}
            {!isLargeSCreen && (
              <div
                className="icon-wrapper settings-small-screen-icon"
                onClick={() => {
                  onMenuSettingsBtnClicked();
                }}
                title="Settings"
              >
                <IonRouterLink routerLink={routerLink}>
                  <IonIcon
                    icon={ellipsisVertical}
                    onClick={(e: any) => {
                      e.persist();
                      closeMenu();
                    }}
                  />
                </IonRouterLink>
              </div>
            )}
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent class="ion-padding">
        <IonButtons onClick={openMenu}></IonButtons>
      </IonContent>




      <IonPopover
        className="menu-list-content"
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() =>
          setShowPopover({ showPopover: false, event: undefined })
        }
      >
        <MenuSettingsList
          isActive={() => {
            setIsHeaderActive(true);
          }}
          isInactive={() => {
            setIsHeaderActive(false);
          }}
          isMyContactNumberClicked={isMyContactNumberClicked}
        />
      </IonPopover>

      <IonModal
        isOpen={showStatusMessage}
        backdropDismiss={false}
        className="status-message-modal"
      >
        <div className="label-div">
          <div className="label-name">{t("statusMessageTitle")}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowStatusMessage(false);
              setStatusMessage("");
            }}
          ></div>
        </div>
        <form className="status-message-input-container" autoComplete="off">
          <div className="comment-box-section">
            <IonTextarea
              className="textarea-div"
              maxlength={50}
              value={statusMessage}
              placeholder={t("enterStatusMessage")}
              id="groupSmsText"
              onIonChange={(e) => {
                setStatusMessage(e.detail.value!);
              }}
            ></IonTextarea>
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setStatusMessage("");
              }}
            >
              {t("clear")}
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            {!messageAvailable ? (
              <IonButton
                disabled={isEmptyMessage}
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  updateStatusMessage();
                  setShowStatusMessage(false);
                }}
              >
                {t("update")}
              </IonButton>
            ) : (
              <IonButton
                disabled={isEmptyMessage}
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  addStatusMessage();
                  setShowStatusMessage(false);
                }}
              >
                {t("add")}
              </IonButton>
            )}
          </div>
        </div>
      </IonModal>

      {/* Language Switcher */}
      {/* <div className="language-switcher-container">
        <IonLabel>{t("language")}</IonLabel>
        <IonSelect
          value={i18n.language}
          interface="popover"
          className="language-select"
          onIonChange={(e) => changeLanguage(e.detail.value)}
        >
          <IonSelectOption value="en">{t("english")}</IonSelectOption>
          <IonSelectOption value="fr">{t("french")}</IonSelectOption>
        </IonSelect>
      </div> */}
    </div>
  );
};

export default Header;

const N2NIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="none">
      <path
        d="M22.5 22.5L26.25 26.25"
        stroke="#4554fa"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26C20.6274 26 26 20.6274 26 14Z"
        stroke="#4554fa"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 19V9H11.0872L17.5203 16.2H16.5078V9H19V19H16.9283L10.4798 11.8H11.4922V19H9Z"
        fill="#4554fa"
      />
    </svg>
  );
};
